export default class Event {
    constructor(id, name, startDate, endDate, location, description, contact_email, race_type, registration_end) {
        this.id = id;
        this.name = name;
        this.startDate = startDate;
        this.endDate = endDate;
        this.location = location;
        this.description = description;
        this.contact_email = contact_email;
        this.race_type = race_type;
        this.registration_end = registration_end;
    }
}

export const demoEvents = [
    {
        id: 1,
        name: "Hanzeregatta 2026 & NK Langebaan",
        startDate: "2026-06-06",
        endDate: "2026-06-07",
        location: "K.V. Skonenvaarder | Reeveweg 2, 8265 PR Kampen",
        contact_email: "hanzeregatta@gmail.com",
        race_type: "(Inter)nationale Wedstrijd"
    },
    {
        id: 2,
        name: "Hanzeregatta 2026 & NK Langebaan",
        startDate: "2026-06-06",
        endDate: "2026-06-07",
        location: "K.V. Skonenvaarder | Reeveweg 2, 8265 PR Kampen",
        contact_email: "hanzeregatta@gmail.com",
        race_type: "(Inter)nationale Wedstrijd"
    },
    {
        id: 3,
        name: "Hanzeregatta 2026 & NK Langebaan",
        startDate: "2026-06-06",
        endDate: "2026-06-07",
        location: "K.V. Skonenvaarder | Reeveweg 2, 8265 PR Kampen",
        contact_email: "hanzeregatta@gmail.com",
        race_type: "(Inter)nationale Wedstrijd"
    },
    {
        id: 4,
        name: "Hanzeregatta 2026 & NK Langebaan",
        startDate: "2026-06-06",
        endDate: "2026-06-07",
        location: "K.V. Skonenvaarder | Reeveweg 2, 8265 PR Kampen",
        contact_email: "hanzeregatta@gmail.com",
        race_type: "(Inter)nationale Wedstrijd"
    }
];